<div *ngIf="movie" class="branded-page">
  <img
    *ngIf="backgroundUrl"
    [ngSrc]="backgroundUrl"
    [alt]="movie?.trTitle + ' background image'"
    class="background-image"
    width="200"
    height="150"
    sizes="100vw"
  />
  <video *ngIf="backgroundVideo" [src]="backgroundVideo" [muted]="true" loop autoplay></video>
  <div class="container">
    <div class="menu-container">
      <div class="logo-section">
        <ush-movie-tell-friends [movie]="movie" [compacted]="true"></ush-movie-tell-friends>
        <!-- Logo -->
        <div class="logo-wrapper" *ngIf="customMovieLogo || movie.logoUrl">
          <img
            [alt]="movie?.title + ' logo'"
            [ngSrc]="customMovieLogo || movie.logoUrl"
            [alt]="movie.trTitle + ' logo'"
            sizes="(max-width: 576) 60vw, (max-width: 992px) 50vw, 20vw"
            width="200"
            height="150"
          />
        </div>
        <!-- movie title if logo does not exist -->
        <div class="branded-movie-title title" *ngIf="!movie.logoUrl && !customMovieLogo">
          {{ movie.title }}
        </div>
        <div class="status">{{ movie.releaseMessage }}</div>

        <div class="movie-social-section" *ngIf="movie.socialNetworks">
          <ush-social-links [socialNetworks]="movie.socialNetworks"></ush-social-links>
        </div>
      </div>
      <ush-language-selector *ngIf="langSelectorInMenu"></ush-language-selector>
      <ul class="menu">
        <li *ngFor="let link of brandedPageLinks" [class]="'menu-' + link.name">
          <a
            [class]="'menu-' + link.name"
            [ngClass]="{ selected: section === link.name }"
            *ngIf="!link?.isExternal"
            (click)="gotoSection(link)"
            [attr.data-translate]="'movie-template-a.menu.' + (link.name | cammelCase)"
            >{{ 'movie-template-a.menu.' + (link.name | cammelCase) | translate }}</a
          >
          <a
            [class]="'menu-' + link.name + ' extra-tab'"
            *ngIf="link?.isExternal"
            [href]="link.link"
            queryParamsHandling="preserve"
            target="_blank"
            (click)="trackingLink(link)"
            [attr.data-translate]="'movie-template-a.menu.' + (link.name | cammelCase)"
            >{{ 'movie-template-a.menu.' + (link.name | cammelCase) | translate }}</a
          >
        </li>
      </ul>
    </div>
    <div class="content-wrapper">
      <div class="content">
        <div class="in-cinemas" *ngIf="section === 'in-cinemas'">
          <ng-container *ngIf="inCinemasIsAvailable || demandItEnabled">
            <ush-showtime-streaming-in-cinemas
              [inCinemasAddon]="brandedInCinemasAddon"
              (showsLoaded)="onShowtimesLoaded()"
              [movie]="movie"
            ></ush-showtime-streaming-in-cinemas>
          </ng-container>
        </div>

        <div class="watch-at-home" *ngIf="section === 'watch-at-home'">
          <ng-container *ngIf="watchAtHomeIsAvailable">
            <ng-container *ngIf="hasOnlyOneCountryEnabled">
              <ng-container
                [ngTemplateOutlet]="title"
                [ngTemplateOutletContext]="{ $implicit: 'watch-at-home' }"
              ></ng-container>
            </ng-container>
            <ush-showtime-streaming-watch-at-home
              [movie]="movie"
              (streamingPlatformsLoaded)="onStreamingPlatformsLoaded()"
            ></ush-showtime-streaming-watch-at-home>
          </ng-container>
        </div>

        <!-- banner -->
        <div *ngIf="customMovie?.imageBanner && section === 'synopsis-and-cast'" class="branded-banner">
          <img
            [ngSrc]="customMovie?.imageBanner.src"
            [alt]="customMovie?.imageBanner?.alt || 'banner'"
            sizes="(max-width: 576) 90vw, 30vw"
            class="synopsis-banner"
            width="200"
            height="150"
          />
        </div>
        <!-- -->
        <div class="synopsis-and-cast" *ngIf="section === 'synopsis-and-cast'">
          <ng-container *ngIf="synopsisTopAddon">
            <ng-container [ngTemplateOutlet]="synopsisTopAddon"></ng-container>
          </ng-container>
          <ush-movie-synopsis [movie]="movie"></ush-movie-synopsis>
          <div *ngIf="synopsisPoster" class="synopsis-poster">
            <img
              [ngSrc]="movie.portraitPhotoUrl || portraitPlaceholder"
              width="225"
              height="350"
              style="height: auto"
              [alt]="movie.title"
              [modal]="{ src: movie.portraitPhotoUrl, type: 'portrait', movie: movie, imgType: 'poster-img' }"
            />
          </div>
          <div *ngIf="movie.trReasonsToWatch" id="reasons-to-watch" class="section">
            <ush-movie-reasons-to-watch [movie]="movie"></ush-movie-reasons-to-watch>
          </div>
          <ush-movie-reviews *ngIf="disableReviews" [movie]="movie"></ush-movie-reviews>
          <ush-movie-credits [movie]="movie"></ush-movie-credits>
          <ush-movie-more-information
            [movie]="movie"
            [channel]="channel"
            [showTPAffinity]="customMovie?.filmAffinity"
          ></ush-movie-more-information>
        </div>

        <div class="sign-up" *ngIf="section === 'sign-up'">
          <ush-showtime-streaming-subscribe *ngIf="demandItEnabled" [movie]="movie" [type]="'in-cinemas'">
          </ush-showtime-streaming-subscribe>
        </div>

        <div class="social-updates" *ngIf="section === 'social-updates'">Social updates</div>

        <div class="contact" *ngIf="section === 'contact'">Contact</div>

        <ng-container *ngFor="let extraSection of brandedExtraSection">
          <div *ngIf="section === extraSection.trName" id="{{ extraSection.trName }}" class="{{ extraSection.trName }}">
            <ng-container [ngTemplateOutlet]="extraSection.contentTemplate"></ng-container>
          </div>
        </ng-container>

        <div class="gallery" *ngIf="galleryOpen">
          <ng-template
            [ngTemplateOutlet]="gallery"
            [ngTemplateOutletContext]="{ $implicit: movie, isMobile: isMobile$ | async }"
          />

          <ng-template #gallery let-isMobile="isMobile" let-movie>
            <p-galleria
              *ngIf="movie?.movieImages"
              [value]="movie.movieImages"
              [(visible)]="galleryOpen"
              [responsiveOptions]="responsiveOptions"
              [containerStyle]="{ width: isMobile ? '75%' : '55%' }"
              [numVisible]="9"
              [circular]="true"
              [fullScreen]="true"
              [showItemNavigators]="true"
              [showThumbnailNavigators]="false"
              [baseZIndex]="100000"
            >
              <ng-template pTemplate="item" let-item>
                <img
                  [alt]="item?.title + ' poster image'"
                  class="galleria-main-image"
                  [src]="item.imageUrl | img"
                  sizes="75vw"
                  [srcset]="getGallerySrcSets(item.imageUrl)"
                  style="width: 100%; display: block"
                />
              </ng-template>
              <ng-template pTemplate="thumbnail" let-item>
                <div class="p-grid p-nogutter p-justify-center">
                  <img
                    class="galleria-thumbnail-image"
                    [alt]="item?.title + ' thumbnail image'"
                    [src]="item.imageUrl | img: { width: 90, height: 60, fit: 'cover' }"
                    style="width: 90px; height: 60px"
                  />
                </div>
              </ng-template>
            </p-galleria>
          </ng-template>

          <span *ngIf="!movie || !movie.movieImages">{{ 'movie-template-a.no-images' | translate }}</span>
        </div>
      </div>
    </div>
  </div>
  <div class="branded-footer" *ngIf="movie.copyrightImageUrl">
    <img
      [ngSrc]="movie.copyrightImageUrl"
      [alt]="movie?.trTitle + ' copyright'"
      sizes="90vw"
      style="width: 100%; height: auto"
      width="500"
      height="150"
    />
  </div>
  <ush-footer id="branded-page-footer" [transparentBackground]="footerTransparentBackground"></ush-footer>
</div>

<ng-template #title let-title>
  <span class="title" [attr.data-translate]="'title.' + (title | cammelCase)">{{
    'title.' + (title | cammelCase) | translate
  }}</span>
</ng-template>
